import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import placeholder from '../assets/user-profile-photo.png';
import { getUploadUrl } from '../util/utilFunctions';
import { API_URL_BASE } from '../util/axiosInstance';

function Row({ label, value, bold }) {
  return <div className="d-flex flex-column flex-sm-row align-items-start mb-2"><div className="text-muted me-sm-2" style={{ minWidth: 150 }}>{label}:</div><div className={bold ? 'fw-semibold' : ''}>{value || 'N/A'}</div></div>;
}

export default function VerSocioQRModal() {
  const { id: token } = useParams();
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [socio, setSocio] = useState(null);
  const [imgSrc, setImgSrc] = useState(placeholder);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    async function loadSocio() {
      if (!token) { setError('Codigo de verificacion no provisto en la URL.'); setLoading(false); return; }
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL_BASE}/socios/verify/${encodeURIComponent(token)}`);
        const data = response.data;
        if (!active) return;
        setSocio(data);
        const foto = data.foto ? getUploadUrl(data.foto) : null;
        setImgSrc(foto || placeholder);
      } catch (err) {
        if (active) setError('No se pudo verificar la informacion del socio.');
      } finally {
        if (active) setLoading(false);
      }
    }
    loadSocio();
    return () => { active = false; };
  }, [token]);

  const handleClose = () => {
    setShow(false);
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  const nombreCompleto = [socio?.nombres, socio?.apPat, socio?.apMat].filter(Boolean).join(' ');
  const estadoActivo = socio?.estado === '1' || socio?.estado === 1;

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false} fullscreen="md-down">
      <Modal.Header closeButton><Modal.Title>Verificacion de Asociado</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3"><img src={process.env.PUBLIC_URL + '/assets/cabeceraciab.png'} alt="CIAB - Filial Tarija" className="img-fluid rounded" /></div>
        {loading && <div className="d-flex align-items-center gap-2"><Spinner animation="border" size="sm" /><span>Cargando...</span></div>}
        {!loading && error && <div className="alert alert-danger mb-0">{error}</div>}
        {!loading && !error && socio && (
          <div className="row g-4">
            <div className="col-12 col-md-4"><div className="border rounded overflow-hidden bg-light" style={{ aspectRatio: '1 / 1' }}><img src={imgSrc || placeholder} alt="Foto del asociado" className="w-100 h-100" style={{ objectFit: 'cover' }} onError={() => setImgSrc(placeholder)} /></div></div>
            <div className="col-12 col-md-8">
              <div className="d-flex align-items-start justify-content-between gap-2 mb-3"><div><div className="text-muted small">Asociado CIAB Tarija</div><h4 className="mb-0">{nombreCompleto}</h4></div><Badge bg={estadoActivo ? 'success' : 'secondary'}>{estadoActivo ? 'Activo' : 'Inactivo'}</Badge></div>
              <Row label="Registro" value={socio.codreg} bold />
              <Row label="CI" value={socio.ci} />
              <Row label="Titulo" value={socio.tit || socio.grado} />
              <Row label="Nro. titulo" value={socio.nrotit} />
              <Row label="Universidad" value={socio.suniv || socio.universidad} />
              <Row label="Celular" value={socio.celular} />
              <Row label="Email" value={socio.email} />
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer><Button variant="secondary" onClick={handleClose}>Cerrar</Button></Modal.Footer>
    </Modal>
  );
}
